import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const LocationPointerFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12.03 12a2.46 2.46 0 1 0 0-4.92 2.46 2.46 0 0 0 0 4.92Z" />
      <Path d="M19.8 9.4c-.34-2.54-1.87-4.89-4.04-6.18a7.683 7.683 0 0 0-3.92-1.1c-.63 0-1.26.08-1.87.26-2.03.58-3.72 2.12-4.75 4C4.43 7.82 4 9.49 4.15 11.14c.37 4.12 3.92 7.54 6.74 10.13.22.21.46.41.74.53.12.05.26.08.39.08.3 0 .6-.12.83-.32 1.94-1.71 3.58-3.61 5.18-5.64 1.1-1.4 1.75-3.17 1.84-4.97.03-.51 0-1.03-.06-1.54l-.01-.01Zm-7.77 4.18c-2.23 0-4.04-1.81-4.04-4.04S9.8 5.5 12.03 5.5s4.04 1.81 4.04 4.04-1.81 4.04-4.04 4.04Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default LocationPointerFilled
